import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {PostLoginRequest} from '../../../afb-api/models/token';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'awair-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss']
})

export class LoginFormComponent implements OnInit {
  @ViewChild('emailView') emailView;

  @Input() isLoggingIn: boolean = false;
  @Input() isLoggedIn: boolean = false;

  get errorMessage(): string {
    if (this._errorMessage != null) {
      return this._errorMessage;
    }
  }
  @Input()
  set errorMessage(value: string) {
    if (value != null) {
      this._errorMessage = value;
      this.form.reset();

      this.isWarning = true;
      setTimeout(() => {
        this.isWarning = false;
      }, 3000);

      // Focus back to email
      this.emailView.nativeElement.focus();
    } else {
      this._errorMessage = '';
    }
  }
  private _errorMessage: string = '';

  @Output() submitForm: EventEmitter<PostLoginRequest> = new EventEmitter<PostLoginRequest>();

  form: FormGroup = new FormGroup({
    email: new FormControl({value: '', disabled: this.isLoggingIn}, Validators.required),
    password: new FormControl({value: '', disabled: this.isLoggingIn}, [
      Validators.required,
      Validators.minLength(6),
      Validators.maxLength(20)
    ])
  });
  isWarning: boolean = false;
  forgotPasswordUrl: string = `${environment.oAuthLogin}forgot-password.html`;

  constructor() {
  }

  ngOnInit() {
  }

  login() {
    if (this.form.valid) {
      this.submitForm.emit(this.form.value);
    }
  }
}
